(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  const toneClasses = ['theme-tone--neutral', 'theme-tone--gold', 'theme-tone--silver', 'theme-tone--rose-gold'];

  const setThemeTone = (tone) => {
    if (!document.body) return;
    document.body.classList.remove(...toneClasses);
    document.body.classList.add(`theme-tone--${tone}`);
  };

  const detectTone = (value) => {
    const normalized = String(value || '').toLowerCase();
    if (normalized.includes('rose gold') || normalized.includes('rosegold') || normalized.includes('rosé gold')) return 'rose-gold';
    if (normalized.includes('silver') || normalized.includes('silber')) return 'silver';
    if (normalized.includes('gold') || normalized.includes('goud')) return 'gold';
    return 'neutral';
  };

  ready(() => {
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    const drawer = document.querySelector('[data-mobile-menu]');

    if (toggle && drawer) {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        drawer.classList.toggle('is-open', !open);
      });
    }

    const product = document.querySelector('[data-product-form]');
    if (!product) {
      setThemeTone('neutral');
      return;
    }

    const section = product.closest('[data-product-section]');
    const variants = Array.from(product.querySelectorAll('[data-variant-select] option')).map((option) => {
      const id = Number(option.value);
      return { id, price: option.dataset.price, available: option.dataset.available === 'true', title: option.textContent.trim() };
    });
    const optionSelects = Array.from(product.querySelectorAll('[data-option-index]'));
    const variantSelect = product.querySelector('[data-variant-select]');

    const updateVariant = () => {
      if (!variantSelect) return;

      let match = variants[0];
      let titleFromSelections = '';

      if (optionSelects.length) {
        titleFromSelections = optionSelects.map((select) => select.value).join(' / ');
        const found = variants.find((variant) => variant.title === titleFromSelections);
        if (found) match = found;
      } else {
        match = variants.find((variant) => String(variant.id) === variantSelect.value) || variants[0];
        titleFromSelections = match?.title || '';
      }

      if (match) {
        variantSelect.value = String(match.id);
        const price = section?.querySelector('[data-product-price]');
        if (price) price.textContent = match.price;
        setThemeTone(detectTone(match.title || titleFromSelections));
      }
    };

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
    updateVariant();
  });
})();
